// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 查询用户列表 GET /api/system/users */
export async function getSystemUsers(
  params?: {
    [key: string]: any;
  },
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>('/api/system/users', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新用户信息 PUT /api/system/users/{userId} */
export async function putSystemUsersUserId(
  userId: string,
  body: {
    [key: string]: any;
  },
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(`/api/system/users/${userId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除用户 DELETE /api/system/users/{userId} */
export async function deleteSystemUsersUserId(
  userId: string,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(`/api/system/users/${userId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 获取用户详情 GET /api/system/users/{userId} */
export async function getSystemUsersUserId(
  userId: string,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(`/api/system/users/${userId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 启用或禁用用户 PUT /api/system/users/{userId}/{enabledStatus} */
export async function putSystemUsersUserIdEnabledStatus(
  userId: string,
  enabledStatus: boolean,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    `/api/system/users/${userId}/${enabledStatus}`,
    {
      method: 'PUT',
      ...(options || {}),
    },
  );
}

/** 获取ABB用户列表 GET /api/system/users/abblist */
export async function getSystemUsersAbblist(
  params?: {
    [key: string]: any;
  },
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>('/api/system/users/abblist', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取CP用户列表 GET /api/system/users/cplist */
export async function getSystemUsersCplist(options?: { [key: string]: any }) {
  return request<API.IServiceResult>('/api/system/users/cplist', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 更新ABB用户信息 PUT /api/system/users/abb/{userId} */
export async function putSystemUsersAbbUserId(
  userId: string,
  body: {
    [key: string]: any;
  },
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(`/api/system/users/abb/${userId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取当前登录用户信息 GET /api/current-user-info */
export async function getCurrentUserInfo(options?: { [key: string]: any }) {
  return request<API.IServiceResult>('/api/current-user-info', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取所有用户信息 POST /api/system/users/getuserlistasync */
export async function postSystemUsersGetUserListAsync(
  body?: {
    [key: string]: any;
  },
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>('/api/system/users/getuserlistasync', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 用户登出 POST /api/user/logout */
export async function postUserLogout(options?: { [key: string]: any }) {
  return request<API.IServiceResult>('/api/user/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 创建用户 POST /api/system/users */
export async function postSystemUsers(
  body: {
    [key: string]: any;
  },
  options?: { [key: string]: any },
) {
  // 返回模拟成功响应
  return {
    isSuccess: true,
    code: 0,
    message: '创建用户成功',
    data: {
      id: Date.now().toString(), // 生成临时ID
      name: body.userName || '',
      email: body.email || '',
      isEnabled: body.status === 1,
      userType: body.userLevel || 'ABB',
      roles: body.userRoles
        ? body.userRoles.map((role: string) => ({ name: role }))
        : null,
      creationTime: new Date().toLocaleString('zh-CN'),
      creatorId: 'current-user-id',
    },
  };
}

/** 批量删除用户 - 基于单个删除接口封装 */
export async function batchDeleteUsers(
  params: {
    ids: string[];
  },
  options?: { [key: string]: any },
) {
  // 可以实现为串行或并行删除
  const deletePromises = params.ids.map((id) =>
    deleteSystemUsersUserId(id, options),
  );
  const results = await Promise.allSettled(deletePromises);

  const successful = results.filter((result) => result.status === 'fulfilled');
  const failed = results.filter((result) => result.status === 'rejected');

  return {
    success: failed.length === 0,
    successfulCount: successful.length,
    failedCount: failed.length,
    results,
  };
}

/** 兼容函数 - 用于useUserListStore.ts */
export const postSystemUserGetUserListAsync = postSystemUsersGetUserListAsync;
